export const EVENTS_QUERY_KEY_ALL = 'allEvents';
export const EVENTS_QUERY_KEY_UPCOMING = 'upcomingEvents';
export const UPCOMING_FLAG = 'UPCOMING';
export const SYSTEM_NAME_FLAG = 'CFDPORTAL';
export const DEFAULT_EVENTS_PAGE = 1;
export const DEFAULT_EVENTS_SIZE_PER_PAGE = 3;
